<app-side-nav></app-side-nav>
<div class="w-full mx-auto max-w-lg md:w-full md:max-w-5xl flex flex-col flex-1 min-h-[calc(100vh-200px)]">  <!-- flex-1 + min-h -->
  <app-header></app-header>
  <div class="flex w-full flex-col max-w-lg mx-auto md:max-w-7xl flex-1">
    <div class="flex-1 overflow-auto">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<app-bottom-nav></app-bottom-nav>
<app-footer></app-footer>
